export enum UBXColor {
    Prm = 'prm',
    Sec = 'sec',
    Ter = 'ter',
    Qua = 'qua',
    Qui = 'qui',
    Scs = 'scs',
    Dgr = 'dgr',
    Wrn = 'wrn',
    Inf = 'inf',
    Lte = 'lte',
    Drk = 'drk',
    Wht = 'wht',
    Blk = 'blk',
}
